import _ from 'lodash';

export default async function filterAsync(array, predicate) {
  const filteredOut = {};

  const values = await Promise.all(
    _.map(array, async value => ((await predicate(value)) ? value : filteredOut))
  );

  return _.filter(values, value => value !== filteredOut);
}
